// extracted by mini-css-extract-plugin
module.exports = {"mapWrapper":"ImageMapWidget_mapWrapper__1kA6a","imageWrapper":"ImageMapWidget_imageWrapper__OPk6d","image":"ImageMapWidget_image__2b6vV"};